import { faClock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import Countdown, { CountdownRendererFn } from "react-countdown";
import { Trans, useTranslation } from "react-i18next";

import { Expert } from "../../models/expert";
import dayjs from "../../services/dayjs";

interface Props {
  expert?: Expert;
  className?: string;
  defaultElement?: boolean
}

const ExpertAvailabilitlyBadge: React.FC<Props> = ({ expert, defaultElement, className }) => {
  const { t } = useTranslation("expert");

  const now = dayjs();
  const nextExpertAvailability = expert?.planning?.slots.find((s) => s.end.isAfter(now));

  const renderCountUp: CountdownRendererFn = ({
    hours, minutes, seconds, total,
  }) => (
    <span className="ml-1 font-semibold">
      {`${hours.toLocaleString("fr-CH", { minimumIntegerDigits: 2 })}${t("common:hourLetter")} 
        ${minutes.toLocaleString("fr-CH", { minimumIntegerDigits: 2 })}${t("common:minuteLetter")} 
        ${seconds.toLocaleString("fr-CH", { minimumIntegerDigits: 2 })}${t("common:secondLetter")}`}
    </span>
  );

  if (expert?.queue?.items[0]?.startedAt && expert?.queue.items[0].type !== "BREAK") {
    return (
      <div className={`bg-orange-100 text-center text-orange-600 text-sm font-medium flex items-center px-2.5 py-1
      rounded-sm border-orange-400 whitespace-nowrap ${className}`}
      >
        <FontAwesomeIcon className="w-3 h-3 mr-2" icon={faClock} />
        <Trans
          i18nKey="busySince"
          ns="expert"
          components={[
            <Countdown overtime date={dayjs(expert.queue?.items?.[0].startedAt).toDate()} renderer={renderCountUp} />,
          ]}
        />
      </div>
    );
  }

  if (!expert.presenceStatus.activityStatus && nextExpertAvailability && nextExpertAvailability.start.isAfter(now)) {
    return (
      <div className={`bg-blue-100 text-blue-800 text-sm font-medium flex items-center px-2.5 py-1
      rounded-sm border-blue-400 whitespace-nowrap ${className}`}
      >
        <FontAwesomeIcon className="w-3 h-3 mr-2" icon={faClock} />
        {t("backAt", {
          time: nextExpertAvailability.start.format(`${nextExpertAvailability.start.day() !== now.day() ? "ddd " : ""}LT`),
        })}
      </div>
    );
  }

  return <></>;
};

export default ExpertAvailabilitlyBadge;
